import React, { useEffect, useState } from "react";
import { Col, Container, Input, Label, Row } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import { useSelector } from "react-redux";
import { DEFAULT_DATE_FORMAT } from "../../constants";

const CreateInvoiceSearchFilters = ({
  onSearch,
  onCsvExportRequested,
  onFilterChanged,
  onInvoiceDateChanged,
  onReset,
}) => {

  const [filters, setFilters] = useState({
    from: moment()
      .subtract(1, "months")
      .startOf("month")
      .format(DEFAULT_DATE_FORMAT),
    to: moment()
      .subtract(1, "months")
      .endOf("month")
      .format(DEFAULT_DATE_FORMAT),
    clientIds: [],
  });
  const [exporting, setExporting] = useState(false);
  const [invoiceDate, setInvoiceDate] = useState(moment().format(DEFAULT_DATE_FORMAT));
  const clientList = useSelector(state => state.clients && state.clients.items);

  useEffect(() => {
    if(onFilterChanged) {
      onFilterChanged(filters);
    }
  }, [filters]);

  const onInvoiceDateChangedInternal = (date) => {
    const formattedDate = date.format(DEFAULT_DATE_FORMAT);
    setInvoiceDate(formattedDate)
    onInvoiceDateChanged && onInvoiceDateChanged(formattedDate);
  };

  const onResetInternal = () => {
    setFilters({
      from: moment()
        .subtract(1, "months")
        .startOf("month")
        .format(DEFAULT_DATE_FORMAT),
      to: moment()
        .subtract(1, "months")
        .endOf("month")
        .format(DEFAULT_DATE_FORMAT),
      clientIds: [],
    });

    onReset && onReset();
  };

  const onCsvExportRequestedInternal = async () => {
    setExporting(true);
    if(onCsvExportRequested) {
      await onCsvExportRequested();
    }
    setExporting(false);
  };

  return (
    <React.Fragment>
      <Row className="align-items-end">
        <Col sm={12} md={7} lg={6}>
          <Row
            className="align-items-center mb-1"
            style={{ marginBottom: "12px" }}
          >
            <Col sm={4} md={3}>
              <Label for="clientId">Client Name</Label>
            </Col>
            <Col sm={8} md={9}>
              <Select
                name="clientId"
                value={filters.clientIds}
                multi={true}
                clearable={false}
                simpleValue={true}
                options={[{ id: "All", companyName: "All" }, ...clientList]}
                onChange={(value) => setFilters({ ...filters, clientIds: !value ? [] : value.split(",").map(x => Number(x)) })}
                valueKey="id"
                labelKey="companyName"
              />
            </Col>
          </Row>
          <Row className="align-items-center full-width-datepicker">
            <Col sm={4} md={3}>
              <Label for="from">From</Label>
            </Col>
            <Col sm={8} md={4} className="mb-1">
              <DatePicker
                onChange={(date) => setFilters({ ...filters, from: date.format(DEFAULT_DATE_FORMAT) })}
                value={filters.from}
                placeholderText="Date From"
                locale="en-au"
                readOnly={false}
                popperPlacement="bottom-end"
                popperModifiers={{
                  offset: {
                    enabled: true,
                    offset: "5px, 10px",
                  },
                  preventOverflow: {
                    enabled: true,
                    escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                    boundariesElement: "viewport",
                  },
                }}
                className="form-control"
              />
            </Col>
            <Col sm={4} md={1}>
              <Label for="to">To</Label>
            </Col>
            <Col sm={8} md={4} className="mb-1">
              <DatePicker
                onChange={(date) => setFilters({ ...filters, to: date.format(DEFAULT_DATE_FORMAT) })}
                value={filters.to}
                placeholderText="Date To"
                locale="en-au"
                readOnly={false}
                popperPlacement="bottom-end"
                popperModifiers={{
                  offset: {
                    enabled: true,
                    offset: "5px, 10px",
                  },
                  preventOverflow: {
                    enabled: true,
                    escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                    boundariesElement: "viewport",
                  },
                }}
                className="form-control"
                minDate={filters.from ? moment(filters.from) : moment()}
              />
            </Col>
          </Row>
          <div className="mt-1 mb-3">
            <button className="btn btn-primary" onClick={onSearch}>
              <i className="fa fa-search" aria-hidden="true"></i> &nbsp;Search
            </button>
            <button className="btn btn-default ml-2" onClick={onResetInternal}>
              Reset
            </button>
          </div>
          <Row className="mb-1">
            <Col sm={4} md={3}>
              <Label for="rctiCreationDate" className="mt-h">
                Date
              </Label>
            </Col>
            <Col sm={8} md={9}>
              <DatePicker
                onChange={(e) => onInvoiceDateChangedInternal(e)}
                value={invoiceDate}
                placeholderText="Date"
                locale="en-au"
                readOnly={false}
                popperPlacement="bottom-end"
                popperModifiers={{
                  offset: {
                    enabled: true,
                    offset: "5px, 10px",
                  },
                  preventOverflow: {
                    enabled: true,
                    escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                    boundariesElement: "viewport",
                  },
                }}
                className="form-control"
                minDate={moment()}
              />
            </Col>
          </Row>
        </Col>

        <Col sm={12} md={5} lg={6}>
          <div className="float-right mb-1">
            <button
              className={`btn btn-success bold ${
                exporting ? "no-pointer-events" : ""
              }`}
              onClick={onCsvExportRequestedInternal}
              disabled={exporting}
            >
              {exporting ? "Exporting" : "Export CSV"}
            </button>
          </div>
          <div className="clearfix" />
        </Col>
      </Row>
    </React.Fragment>
  );
};
export default CreateInvoiceSearchFilters;
